export default {
  region: process.env.REACT_APP_REGION,
  env: process.env.NODE_ENV,
  // root: 'https://ofpw8yar0c.execute-api.us-east-1.amazonaws.com/prod',
  // root: 'https://8flg6gmb8f.execute-api.us-east-1.amazonaws.com/prod',
  root: 'https://bogl3mkc9b.execute-api.us-east-1.amazonaws.com/prod',
  timeoutInMinutes: process.env.REACT_APP_TIMEOUT_MINUTES
};
